import { render, staticRenderFns } from "./IconGerman.vue?vue&type=template&id=f9a03e38"
import script from "./IconGerman.vue?vue&type=script&lang=js"
export * from "./IconGerman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports